<template>
    <modal ref="modal" unclosable>
        <div id="sub-wrapper">
            <div class="text" v-html="$t('modals.logout.text', { email: email })"></div>
            <button @click="hide">{{ $t('modals.logout.button') }}</button>
        </div>
    </modal>
</template>

<script>
export default {
  data () {
    return {
      email: ''
    }
  },
  methods: {
    show (email) {
      this.email = email
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 30em;
}

#sub-wrapper .text {
  margin-bottom: 1.5em;
}

</style>
